module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-active@2x-438b4965.png";